module.exports = __webpack_public_path__ + "img/icon_white-small_pin-location.204a6893.svg";